import { Button, Group, TextInput } from '@mantine/core';
import { useCreateBookmarkByUrlMutation } from '@metto/ui-web/domains/bookmarks';
import { Form } from '@metto/ui-web/shared/components';
import type { CreateBookmarkByUrlFormData } from './useCreateBookmarkByUrlForm';
import { useCreateBookmarkByUrlForm } from './useCreateBookmarkByUrlForm';

type Props = {
  close: () => void;
};

const AddButtonForm = ({ close }: Props) => {
  const form = useCreateBookmarkByUrlForm();
  const { mutateAsync } = useCreateBookmarkByUrlMutation();
  const { register, resetField } = form;

  const handleSubmit = async ({ url }: CreateBookmarkByUrlFormData) => {
    try {
      reset();
      await mutateAsync({
        body: {
          values: { url }
        }
      });
    } catch (err: any) {
      console.error(err);
    }
  };

  const reset = () => {
    resetField('url');
    close();
  };

  return (
    <Form onSubmit={form.handleSubmit(handleSubmit)}>
      <TextInput
        placeholder="Enter a URL"
        {...register('url')}
        error={form.formState.errors.url?.message}
        mb="sm"
      />
      <Group gap="xs">
        <Button type="submit">Submit</Button>
        <Button onClick={reset} type="reset" variant="white">
          Cancel
        </Button>
      </Group>
    </Form>
  );
};

export default AddButtonForm;
